module.exports = __webpack_public_path__ + "static/media/general-garbageRoom.cb8f0652.png";